import React, { useEffect, useState } from 'react';
import { formatSeoApiError, listVisaRecords } from '../../../utils/adminSeo';

export default function SeoVisaDataScreen() {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');
  useEffect(() => {
    setErr('');
    listVisaRecords()
      .then((r) => setRows(r.visa || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Visa Data Manager</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-2 text-left">Destination</th>
              <th className="p-2">Status</th>
              <th className="p-2">Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((v) => (
              <tr key={v.id} className="border-t">
                <td className="p-2">{v.destination_name || v.slug}</td>
                <td className="p-2 text-center">{v.visa_required_status || '—'}</td>
                <td className="p-2 text-center">{v.source}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
